import { useQuery } from '@tanstack/react-query';
import type { Station } from '@hcc/types';
import { api } from '../lib/api';
import type { PersonApi } from './usePeople';

export interface OutstandingItem {
  station: Station;
  name: string;
  outstanding_quantity: number;
  size_required: boolean;
}

export interface OutstandingForPerson {
  person: { id: string; full_name: string; position: string | null; email: string };
  outstanding: OutstandingItem[];
}

export function useAttendanceReport() {
  return useQuery({
    queryKey: ['reports', 'attendance'],
    queryFn: async () => (await api<{ people: PersonApi[] }>('/api/reports/attendance')).people,
  });
}

export function useNoShowsReport() {
  return useQuery({
    queryKey: ['reports', 'no-shows'],
    queryFn: async () => (await api<{ people: PersonApi[] }>('/api/reports/no-shows')).people,
  });
}

export function useOutstandingReport() {
  return useQuery({
    queryKey: ['reports', 'outstanding'],
    queryFn: async () =>
      (await api<{ outstanding: OutstandingForPerson[] }>('/api/reports/outstanding')).outstanding,
  });
}
